import { initRum, setRumUser, recordRumEvent, recordRumError } from '@pac/cloudwatch-rum';
import rumConfig from '../config/cloudwatch-rum';
import { stage } from '../config/stage';

// RUM is observability infrastructure — it must never block the login app from
// rendering. A failure here cannot be allowed to affect the sign-in flow.
try {
    initRum({ config: rumConfig, stage });
} catch (error) {
    console.warn('[CloudWatch RUM] init skipped:', error);
}

export { setRumUser, recordRumEvent, recordRumError };
